import config from '../config';
import axios from 'axios';

const DRAFT_API_BASE = `${config.NODE_API_BASE_URL_V2}/entityKycDraft`;

export const getEntityKycDraft = async (ssoUserID: string) => {
    try {
        const response = await axios.get(`${DRAFT_API_BASE}/${ssoUserID}`);
        // Return full draft object to allow status checks
        return response.data?.data; 
    } catch (error) {
        console.error("Error fetching draft:", error);
        return null;
    }
};

export const updateEntityKycDraftStep = async (ssoUserID: string, stepKey: string, data: any) => {
    try {
        const response = await axios.put(`${DRAFT_API_BASE}/${ssoUserID}`, {
            stepKey,
            data
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating draft step ${stepKey}:`, error);
        throw error;
    }
};

export const uploadEntityKycDraftFiles = async (ssoUserID: string, files: File[]) => {
    try {
        const formData = new FormData();
        formData.append("ssoUserID", ssoUserID);
        files.forEach(file => formData.append("files", file));

        const response = await axios.post(`${DRAFT_API_BASE}/upload`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data?.data; // Returns array of { filename, url }
    } catch (error) {
        console.error("Error uploading draft files:", error);
        throw error;
    }
};

export const submitEntityKycDraft = async (ssoUserID: string) => {
    try {
        const response = await axios.post(`${DRAFT_API_BASE}/submit/${ssoUserID}`);
        return response.data;
    } catch (error) {
        console.error("Error submitting draft:", error);
        throw error;
    }
};
